import { render, staticRenderFns } from "./mobile-noteother.vue?vue&type=template&id=07ca6f74&scoped=true&"
import script from "./mobile-noteother.vue?vue&type=script&lang=js&"
export * from "./mobile-noteother.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca6f74",
  null
  
)

export default component.exports